import { create } from 'zustand';
import { CondoStore, __test__ } from './slices/shared';
import { createCoreSlice } from './slices/core';
import { createCondosUnitsSlice } from './slices/condosUnits';
import { createOwnersSlice } from './slices/owners';
import { createFeesSlice } from './slices/fees';
import { createFinancialsSlice } from './slices/financials';
import { createStatementsPaymentsSlice } from './slices/statementsPayments';
import { createDocumentsSlice } from './slices/documents';
import { createViolationsMaintenanceSlice } from './slices/violationsMaintenance';
import { createUtilitySlice } from './slices/utility';
import { createBoardSlice } from './slices/board';
import { createOperationsSlice } from './slices/operations';
import { createCommsSchedulingSlice } from './slices/commsScheduling';
import { createExtrasSlice } from './slices/extras';

// Re-exported so existing consumers keep importing it from '../condoStore'
// (a spec does `import { useCondoStore, __test__ } from '../condoStore'`).
export { __test__ };
export type { CondoStore };

export const useCondoStore = create<CondoStore>()((...a) => ({
  // Each slice is typed as a Partial<CondoStore> (or, for `extras`, `object`) so
  // it can contribute only its own actions/state. The spread merge therefore
  // widens every property to `T | undefined` at the type level even though the
  // runtime object genuinely carries every member exactly once (no key is
  // defined by two slices). The `as CondoStore` restores the full shape that
  // the composed object provably satisfies — it is a pure typing bridge, not a
  // behaviour change.
  ...createCoreSlice(...a),
  ...createCondosUnitsSlice(...a),
  ...createOwnersSlice(...a),
  ...createFeesSlice(...a),
  ...createFinancialsSlice(...a),
  ...createStatementsPaymentsSlice(...a),
  ...createDocumentsSlice(...a),
  ...createViolationsMaintenanceSlice(...a),
  ...createUtilitySlice(...a),
  ...createBoardSlice(...a),
  ...createOperationsSlice(...a),
  ...createCommsSchedulingSlice(...a),
  ...createExtrasSlice(...a),
} as CondoStore));
